export const TradeInActionTypes = {
  TRADEIN_MODEL_YEAR: 'TRADEIN/MODEL_YEAR',
  TRADEIN_BRANDS: 'TRADEIN/BRANDS',
  TRADEIN_MODELS: 'TRADEIN/MODELS',
  TRADEIN_TRIMS: 'TRADEIN/TRIMS',
};
